import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

// creates a beautiful scrollbar
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { withStyles } from "material-ui";

// un array con due oggetti per fare un redirect o caricare un componente React
import uploadPhotoRoutes from "../../routes/upload-photo";

import appStyle from "../../assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";


/**
 * il componenet disegnato nella pagina
 * per ogni 
 */
const switchRoutes = (
    <Switch>
        {uploadPhotoRoutes.map((prop, key) => {

            if (prop.redirect) {
                return <Redirect from={prop.path} to={prop.to} key={key} />;
            }

            // se non è redirect
            return <Route path={prop.path} component={prop.component} key={key} />;
        })}
    </Switch>
);

class App extends React.Component {
    state = {
        mobileOpen: false
    };

    handleDrawerToggle = () => {
        this.setState({ mobileOpen: !this.state.mobileOpen });
    };

    /**
     * restituisce true se la url non contiene 'mpas'
     * false altrimenti
     * @returns boolean
     */
    getRoute() {
        
        return this.props.location.pathname !== "/maps";
    }

    componentDidMount() {

    }

    componentDidUpdate() {

    }

    render() {
        // const { classes, ...rest } = this.props;
        const { classes } = this.props;
        return (
            <div className={classes.wrapper}>
                <div className={classes.loginPage} ref="login">
                    {
                        this.getRoute()
                            ?
                            (
                                <div>
                                    <div>{switchRoutes}</div>
                                </div>
                            )
                            :
                            (
                                <div className={classes.map}>{switchRoutes}</div>
                            )
                    }
                </div>
            </div>
        );
    }
}

App.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(appStyle)(App);



// WEBPACK FOOTER //
// ./src/layouts/Users/UploadPhoto.jsx